"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/DetailsList/ShimmeredDetailsList"), exports);
tslib_1.__exportStar(require("./components/DetailsList/ShimmeredDetailsList.base"), exports);
//# sourceMappingURL=ShimmeredDetailsList.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/ShimmeredDetailsList.js
// module id = 1179
// module chunks = 0